import { Action } from 'redux';
import { Tab } from '@iv/model/tabs.model';
import * as TabsActions from './tabs.actions';

export interface TabsEntities {
  [id: string]: Tab;
}

export interface TabsState {
  ids: string[];
  entities: TabsEntities;
  currentTabId?: string;
}

const initialState: TabsState = {
  ids: [],
  currentTabId: null,
  entities: {}
};

export const TabsReducer = (state: TabsState = initialState, action: Action): TabsState => {
  switch (action.type) {
    case TabsActions.LOAD_TABS: {
      const tabs = (<TabsActions.LoadTabsAction>action).tabs;
      const ids = tabs.map(tab => {
        return tab.id;
      });
      const entities = {};
      tabs.forEach(tab => {
        Object.assign(entities, {
          [tab.id]: tab
        });
      });
      return {
        ids: ids,
        currentTabId: state.currentTabId, // unchanged
        entities: entities
      };
    }

    case TabsActions.ADD_TAB: {
      const tab = (<TabsActions.AddTabAction>action).tab;
      return {
        ids: [...state.ids, tab.id],
        currentTabId: state.currentTabId, // unchanged
        entities: Object.assign({}, state.entities, {
          [tab.id]: tab
        })
      };
    }

    case TabsActions.SELECT_TAB: {
      const tab = (<TabsActions.SelectTabAction>action).tab;
      Object.keys(state.entities).forEach((oldTab) => state.entities[oldTab].active = false);
      const newTabs = state.entities;
      newTabs[tab.id].active = true;
      return {
        ...state,
        currentTabId: tab.id,
        entities: Object.assign({}, newTabs)
      };
    }

    case TabsActions.DELETE_TAB: {
      const tab = (<TabsActions.DeleteTabAction>action).tab;

      let currentTabId = state.currentTabId;

      if (tab.id === state.currentTabId) {
        let index = state.ids.indexOf(tab.id);
        if (index === (state.ids.length - 1)) {
          index = state.ids.length - 2;
        } else {
          index++;
        }
        currentTabId = state.ids[index];
      }

      const oldTabs = state.entities;
      delete oldTabs[tab.id];

      Object.keys(oldTabs).forEach((oldTab) => oldTabs[oldTab].active = false);

      const newTabs = Object.assign({}, oldTabs);
      newTabs[currentTabId].active = true;
      const newIds = Object.keys(newTabs);

      return {
        ids: newIds,
        currentTabId: currentTabId,
        entities: Object.assign({}, newTabs)
      };
    }

    case TabsActions.UPDATE_TAB_DATA: {
      const field = (<TabsActions.UpdateTabDataAction>action).field.name;
      const value = (<TabsActions.UpdateTabDataAction>action).field.value;
      const entities = state.entities;
      const oldTab = entities[state.currentTabId];
      if (field === 'description') {
        oldTab[field] = value;
      } else {
        oldTab.data[field] = value;
      }
      return {
        ids: state.ids,
        currentTabId: state.currentTabId,
        entities: Object.assign({}, state.entities, {
          [state.currentTabId]: oldTab
        })
      };
    }

    case TabsActions.UPDATE_SERVICE_TAB_DATA: {
      const fieldName = (<TabsActions.UpdateServiceTabDataAction>action).field.name;
      const value = (<TabsActions.UpdateServiceTabDataAction>action).field.value;
      const entities = state.entities;
      const oldTab = entities[state.currentTabId];
      if (fieldName === 'columns'
        || fieldName === 'gridColumns'
        || fieldName === 'defaultColumns'
        || fieldName === 'defaultGridColumns'
        || fieldName === 'visibleColumns'
      ) {
        oldTab.data.serviceTabs[0][fieldName] = value;
      } else {
        oldTab.data.serviceTabs[0].filters[fieldName] = value;
      }
      return {
        ids: state.ids,
        currentTabId: state.currentTabId,
        entities: Object.assign({}, state.entities, {
          [state.currentTabId]: oldTab
        })
      };
    }

    default:
      return state;
  }
};
